import mutations from './mutations'
import actions from './actions'
import getters from'./getters'
export default {
    state: {
        articles: [],
        article_pages: 0,
        currentArticle: {},
        newArticle: {
            slider: [],
            public_at: new Date().toDateString()
        }
    },
    mutations,
    actions,
    getters
}
